import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizFinishedTranslations: Quiz409Translations = {
  title: 'Quiz finished!',
  subMessage: 'You have completed all the tasks in the quiz.',
  buttons: {
    back: 'Start',
  },
};
